import { e as enable_async_mode_flag } from "./index3.js";
enable_async_mode_flag();
